import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ui-spinner__text"
}

import { computed } from "vue";
import type { Size, Variant } from "./types";

interface Props {
  size?: Size;
  variant?: Variant;
  text?: string;
  inline?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
    size: { default: "md" },
    variant: { default: "primary" },
    text: {},
    inline: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const spinnerClasses = computed(() => {
  const classes = ["ui-spinner"];
  classes.push(`ui-spinner--${props.size}`);
  classes.push(`ui-spinner--${props.variant}`);
  if (props.inline) classes.push("ui-spinner--inline");
  return classes;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(spinnerClasses.value)
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "ui-spinner__circle" }, null, -1)),
    (__props.text)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.text), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})